// App.js
import ResponsiveAppBar from "./components/ResponsiveAppBar";
import { useState } from "react";
import { Button, Dialog, DialogActions, DialogContent } from "@mui/material";
import { Route, Routes } from "react-router";
import Home from "./components/Home";
import Notar from "./components/Notar";
import Services from "./components/Services";
import Info from "./components/Info";
import Contact from "./components/Contact";
import Imprint from "./components/Imprint";
import Privacy from "./components/Privacy";
import Security from "./components/Security";
import Footer from "./components/Footer";
import Carrer from "./components/Carrer";
import Blog from "./components/Blog";
import Decisions from "./components/decisions";
import PostDetail from "./components/PostDetail"; // <- NEU
import SGNeubrandenburg from "./components/sgneubrandenburg";
import FGMecklenburgvorpommern from "./components/fgmecklenburgvorpommern";
import OLGSchleswig from "./components/olgschleswig";
import Bundesfinanzhof from "./components/bundesfinanzhofs";
import BundesfinanzhofDarlehen from "./components/bundesfinanzhofdarlehen";
import FGNiedersachsen from "./components/fgniedersachsen";
import FGSchleswig from "./components/fgSchleswig";
import { SecurityDriver } from "./components/core/SecurityDriver";

function App() {
  const [wasShowedMessage, setWasShowedMessage] = useState(
    localStorage.getItem("message_wasserschaden_20260707") === "true"
  );

  const handleClose = () => {
    localStorage.setItem("message_wasserschaden_20260707", "true");
    setWasShowedMessage(true);
  };

  return (
    <div className="App">
      <Dialog open={!wasShowedMessage} onClose={handleClose}>
        <DialogContent>
          Aufgrund eines Wasserschadens entfallen heute (07.07.2026) leider
          sämtliche Termine.
          <br />
          Wir bitten um Ihr Verständnis und melden uns zur Vereinbarung eines
          Ersatztermins bei Ihnen.
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Okay</Button>
        </DialogActions>
      </Dialog>

      <ResponsiveAppBar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Notar" element={<Notar />} />
        <Route path="/Leistungen" element={<Services />} />
        <Route path="/Info" element={<Info />} />
        <Route path="/Kontakt" element={<Contact />} />
        <Route path="/Karriere" element={<Carrer />} />
        <Route path="/Impressum" element={<Imprint />} />
        <Route path="/Datenschutz" element={<Privacy />} />
        <Route path="/Sicherheit" element={<Security />} />
        <Route path="/Blog" element={<Blog />} />

        {/* Liste der Entscheidungen */}
        <Route path="/article" element={<Decisions />} />
        {/* Detailansicht für einen einzelnen Post */}
        <Route path="/article/:slug" element={<PostDetail />} />

        <Route path="/SG-Neubrandenburg" element={<SGNeubrandenburg />} />
        <Route
          path="/FG-Mecklenburg-Vorpommern"
          element={<FGMecklenburgvorpommern />}
        />
        <Route path="/olg-schleswig" element={<OLGSchleswig />} />
        <Route path="/bundesfinanzhof" element={<Bundesfinanzhof />} />
        <Route
          path="/bundesfinanzhof-darlehen"
          element={<BundesfinanzhofDarlehen />}
        />
        <Route path="/fg-niedersachsen" element={<FGNiedersachsen />} />
        <Route path="/fg-schleswig" element={<FGSchleswig />} />

        <Route
          path="/admin"
          element={
            <SecurityDriver>
              <>bla</>
            </SecurityDriver>
          }
        />
      </Routes>

      <Footer />
    </div>
  );
}

export default App;
